export default 'en-US';
